import { useState } from 'react';
import { TaskPage } from '../../../components/workbook/TaskPage';
import { TextArea, TextInput } from '../../../components/workbook/forms';
import { Callout } from '../../../components/workbook/Callout';

export default function EngagementBriefPage() {
  const [purpose, setPurpose] = useState('');
  const [antiGoals, setAntiGoals] = useState('');
  const [stakeholders, setStakeholders] = useState('');
  const [constraints, setConstraints] = useState('');
  const [topRisks, setTopRisks] = useState('');
  const [waysOfWorking, setWaysOfWorking] = useState('');
  const [reviewDate, setReviewDate] = useState('');
  const [owner, setOwner] = useState('');

  return (
    <TaskPage
      phase="engage"
      title="The Engagement Brief"
      pageNumber={7}
      instruction="Create a one-pager to share. Write it in plain language and do a quick clarity check with 5–7 readers before broad rollout."
      whyItMatters="A clear engagement brief ensures everyone understands purpose, constraints, and ways of working."
      coachRail={{
        timing: "10-20 minutes",
        tips: "Keep it concise. One page max. Use plain language.",
        debrief: "What, if anything, is unclear? Share with stakeholders and invite corrections."
      }}
    >
      <div className="space-y-6">
        <div className="bg-[var(--surface)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-pri)] mb-4">Engagement Brief Template</h3>
          <div className="space-y-4">
            <TextArea
              label="Purpose & desired outcomes"
              value={purpose}
              onChange={(e) => setPurpose(e.target.value)}
              placeholder="What are we trying to achieve?"
              rows={3}
            />
            <TextArea
              label="Anti-goals"
              value={antiGoals}
              onChange={(e) => setAntiGoals(e.target.value)}
              placeholder="What are we NOT trying to do?"
              rows={2}
            />
            <TextArea
              label="Stakeholders & roles"
              value={stakeholders}
              onChange={(e) => setStakeholders(e.target.value)}
              placeholder="Who's involved and what are their roles?"
              rows={3}
            />
            <TextArea
              label="Constraints"
              value={constraints}
              onChange={(e) => setConstraints(e.target.value)}
              placeholder="What constraints do we need to work within?"
              rows={2}
            />
            <TextArea
              label="Top risks & first countermeasures"
              value={topRisks}
              onChange={(e) => setTopRisks(e.target.value)}
              placeholder="What are the biggest risks and how will we address them?"
              rows={3}
            />
            <TextArea
              label="Ways of working (decision style, cadence, comms)"
              value={waysOfWorking}
              onChange={(e) => setWaysOfWorking(e.target.value)}
              placeholder="How will we work together?"
              rows={3}
            />
            <div className="grid grid-cols-2 gap-4">
              <TextInput
                label="Review date"
                type="date"
                value={reviewDate}
                onChange={(e) => setReviewDate(e.target.value)}
              />
              <TextInput
                label="Owner"
                value={owner}
                onChange={(e) => setOwner(e.target.value)}
                placeholder="Who owns this brief?"
              />
            </div>
          </div>
        </div>

        <div className="bg-[var(--slate-dim)] border border-[var(--slate)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-sec)] mb-4">Publish & Share</h3>
          <p className="text-sm text-[var(--text-sec)] mb-4">
            Share with stakeholders; invite corrections. Do a quick clarity check with 5–7 readers: "what, if anything, is unclear?"
          </p>
          <Callout type="tip" phase="engage">
            <p className="text-sm">Write in plain language. Avoid jargon. Make it scannable with clear headings.</p>
          </Callout>
        </div>
      </div>
    </TaskPage>
  );
}






